import React from 'react';
import * as Icons from 'lucide-react';

const FeaturesGrid = ({ settings }) => {
    const {
        title = "Why Choose Us",
        features = [],
        bg,
        titleColor,
        featureTitleColor,
        featureTextColor,
        iconColor,
        iconBg
    } = settings;

    return (
        <div
            className="w-full py-12 px-8 md:px-4"
            style={{
                backgroundColor: bg || 'var(--store-bg)',
                color: titleColor || 'var(--store-text)'
            }}
        >
            <div className="max-w-7xl mx-auto">
                {title && (
                    <h2
                        className="text-3xl font-bold text-center mb-12"
                        style={{ color: titleColor || 'inherit' }}
                    >
                        {title}
                    </h2>
                )}

                <div className="grid grid-cols-3 md:grid-cols-1 gap-8">
                    {features.map((feature, index) => {
                        // Dynamically get icon component, fallback to Package if not found
                        const IconComponent = Icons[feature.icon] || Icons.Package;

                        return (
                            <div key={index} className="flex flex-col items-center text-center p-4 transition-transform hover:-translate-y-1">
                                <div
                                    className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
                                    style={{
                                        backgroundColor: iconBg || 'var(--store-card-bg)',
                                        color: iconColor || 'inherit'
                                    }}
                                >
                                    <IconComponent size={32} strokeWidth={1.5} />
                                </div>
                                <h3
                                    className="text-xl font-bold mb-3"
                                    style={{ color: featureTitleColor || 'inherit' }}
                                >
                                    {feature.title}
                                </h3>
                                <p
                                    className="leading-relaxed"
                                    style={{ color: featureTextColor || 'var(--store-muted)' }}
                                >
                                    {feature.text}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default FeaturesGrid;
